export default __webpack_public_path__ + "static/media/gray-watch.5e0526c1.svg";